function gradedSchoolDataComposer(originResources) {
    let dataFields = [];

    let dataHeadConfigs = [
        {index:'rank',name:'Rank'},
        {index:'district',name:'District'},
        {index:'school',name:'School'},
        {index:'norm_score',name:'Normalized Math/Reading Score'},
        {index:'no_score',name:'Num. Scores in Avg'},
        {index:'VA_Read',name:'Reading'},
        {index:'VA_Math',name:'Math'},
        {index:'VA_Sci',name:'Science'},
        {index:'VA_SS',name:'Soc.Stud.'},
        {index:'GPA',name:'GPA'},
        {index:'LitNum',name:'Literacy/Num. Growth Index'},
        {index:'FRL',name:'Free/Reduced Lunch'},
        {index:'system',name:'School System'},
        {index:'division',name:'Division'},
        {index:'grade', name:'Grade'}
    ]
    let gradedRows = [];
    let schoolRows = originResources.school.data.content||originResources.school.data.document;
    let gradeScaleObj = originResources.schoolSetup.data.row.grade_low_scale;
    let gradeScale = [
        {
            grade: 'A',
            value: gradeScaleObj.a,
            gradeColor: '#00d20e',
            gradeContrast:'#464646'
        },
        {
            grade: 'B',
            value: gradeScaleObj.b,
            gradeContrast: '#3c3c3c',
            gradeColor:'#a0af0f'
        },
        {
            grade: 'C',
            value: gradeScaleObj.c,
            gradeContrast: '#404040',
            gradeColor:'#ffd300'
        },
        {
            grade: 'D',
            value: gradeScaleObj.d,
            gradeContrast: '#3a3a3a',
            gradeColor:'#f88500'
        },
        {
            grade: 'F',
            value: gradeScaleObj.f,
            gradeColor: '#a40000',
            gradeContrast:'#ffffff'
        },
    ];

    schoolRows.sort((a, b) => b.norm_score - a.norm_score);
    var uid = 0;
    for (var i = 0; i < schoolRows.length; i++) {
        let schoolRow = schoolRows[i];
        let { score } = schoolRow;

        for (var j = 0; j < gradeScale.length; j++) {
            let { grade, gradeColor,gradeContrast,value } = gradeScale[j];
            if (score >= value) {
                uid++;
                gradedRows.push({ rank: i + 1, ...schoolRow, grade: grade, gradeColor: gradeColor,gradeContrast:gradeContrast,uid:uid });
                break;
            }
        }

    }

    if(gradedRows.length>0){
        for(var i = 0;i<dataHeadConfigs.length;i++){
            if(gradedRows[0][dataHeadConfigs[i].index] != undefined){
                dataFields.push(dataHeadConfigs[i]);
            }
        }
    }
   

    return {
        rows: gradedRows,
        gradeScale: gradeScale,
        high: originResources.schoolSetup.data.row.high,
        low: originResources.schoolSetup.data.row.low,
        title: originResources.schoolSetup.data.row.side_title,
        document_title:originResources.schoolSetup.data.row.top_title,
        high_score:gradedRows[0].score,
        low_score:gradedRows[gradedRows.length-1].score,
        stateAvg:originResources.schoolSetup.data.row.state_avg,
        growthStandard98:0.0086,
        dataFields:dataFields,
        rank_text:`Rank among ${gradedRows.length} ${originResources.schoolSetup.data.row.school_type.toLowerCase()} schools`,
     };
}

export default gradedSchoolDataComposer;